<template>
<div class="chapter">
<div class="inner_page">
<section class="introduction" epub:type="introduction">
<h2><span class="h2-inner">Introduction</span></h2>
<p class="firstInSection">In 1971 I was asked to go to South Africa to take part in the Johannesburg International Horse Show, a two-week-long entertainment similar to Canada’s Royal Winter Fair in Toronto and the Olympia and Wembley indoor horse shows in London, England. The invited party of about twenty international horse people included Olympic show-jumpers Piero d’lnzeo and Anneli Drummond Hay, who jumped local borrowed horses to dazzling effect. I went in the capacity of judge of varying classes of riding horses, a task which meant setting the horses in order according to their looks and then riding them to see if they moved with presence, appointing winners overall.</p>
<p>My wife, Mary, and I stayed with the Show Director, Christopher Coldrey, on his farm out in the country, and in between performances he introduced us to South African private life. We spent a free weekend of three scorching days in the Kruger Park Game Reserve, eyeball to eyeball with lion, elephant, impala, and giraffe, and were shown the back roads and hidden places by one of the senior game wardens. Naturally (for me) we went also to race meetings and there met a man who invited us down to his gold mine, offering a private conducted tour and invaluable knowledge.</p>
<p><em>Smokescreen</em>, written after our return to England, unsurprisingly unfolds against a background of South African racing, a gold mine, and blazing heat in the Kruger Park Game Reserve; and to this day if I glance into the book the beauty and the powerful, sweet scent of the South African countryside fill my memory.</p>
<p>Edward Lincoln, the chief character, is an English film star, and for the authentic background of his job my wife and I went to the British film studios at Pinewood, where we were comprehensively shown how movies are made. We already counted many actors among our friends, as Mary had earlier worked behind the scenes in the theatre, so I usefully knew how good actors behave and think.</p>
<p>As a mix of all these experiences, together with humor and, of course, make-believe, <em>Smokescreen</em> evolved.</p>
<p>This is not a political book, just a matter of fun and suspense.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?0e35748d